import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugAtorvastatin} from "./TextDrugAtorvastatin"


export default function Atorvastatin() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
    
    <ButtonsText onClick={handleOpen} name='Atorvastatin' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Atorvastatin - PGx Recommendation"
        content={ <TextDrugAtorvastatin />}

        />

</>
)}